import React, { useEffect, useState } from "react";
import ItemDrawer from './ItemDrawer';

import {
  firestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot
} from "../firebase" ;
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Snackbar,
  Alert
} from "@mui/material";

import Tooltip from '@mui/material/Tooltip';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import IconButton from '@mui/material/IconButton';

function AdminApprovalPage() {
  const [requests, setRequests] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [selectedreq, setSelectedReq] = useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    const fetchRequests = () => {
      const requestsRef = collection(firestore, "MembershipRequests");
      const q = query(requestsRef, where("status", "==", "pending"));

      // Listen to real-time updates
      const unsubscribe = onSnapshot(q, (snapshot) => {
        setRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      });

      // Cleanup on unmount
      return () => unsubscribe();
    };

    fetchRequests();
  }, []);

  const showStatusMessage = (message, severity = "success") => {
    setStatusMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
    setTimeout(() => setOpenSnackbar(false), 3000);
  };
  

  const handleOpenDrawer = (id) => {
    const member = requests.find(member => member.id === id);
    setSelectedReq(member);
  };

  const handleCloseDrawer = () => {
    setSelectedReq(null);
  };

  const handleApprove = async (request) => {
  try {
    if (!request.personalEmail) {
      showStatusMessage("Error: Email address is missing.");
      return;
    }

    const membersRef = collection(firestore, "MembershipMaster");
    const emailQuery = query(
      membersRef,
      where("personalEmail", "==", request.personalEmail)
    );

    const emailSnapshot = await getDocs(emailQuery);

    const membershipData = {
      ...request,
      status: "approved",   // ✅ FIXED (Capital A)
      membershipStartDate: new Date().toISOString(),   // ✅ ADD THIS
      membershipEndDate: new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      ).toISOString(),
    };

    if (!emailSnapshot.empty) {
      const existingDoc = emailSnapshot.docs[0];
      const memberRef = doc(firestore, "MembershipMaster", existingDoc.id);

      await updateDoc(memberRef, membershipData);
    } else {
      const memberRef = doc(firestore, "MembershipMaster", request.id);
      await setDoc(memberRef, membershipData);
    }

    // Delete from requests
    const requestRef = doc(firestore, "MembershipRequests", request.id);
    await deleteDoc(requestRef);

    handleCloseDrawer();
    showStatusMessage("Member approved and added!", "success");

  } catch (error) {
    console.error("Error approving request:", error);
    showStatusMessage("Error approving member.", "error");
  }
};


  const handleDeny = async (request) => {
    try {
      const requestRef = doc(firestore, "MembershipRequests", request.id);
      // Delete the document from MembershipRequests
      await deleteDoc(requestRef);

      handleCloseDrawer();

      showStatusMessage("Member request denied.","error");
    } catch (error) {
      console.error("Error denying request:", error);
      showStatusMessage("Error denying member.","error");
    }
  };

  return (
    <div style={{ padding: "20px", marginTop:"20px" }}>
      <h2 style={{ textAlign: "center", marginBottom:"30px" }}>Membership Requests</h2>


      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Name</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Email Address</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Membership Category</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>City</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Expertise</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>More Details</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {requests.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" style={{ padding: "20px", textAlign: "center" }}>
                  No pending requests.
                </TableCell>
              </TableRow>
            ) : (
              requests.map((request) => (
                <TableRow key={request.id}>
                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.firstName} {request.surname}</TableCell>
                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.personalEmail || "N/A"}</TableCell>
                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.membershipCategory || "N/A"}</TableCell>
                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.city || "N/A"}</TableCell>
                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.expertise || "N/A"}</TableCell>
                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                    <Tooltip title="More Details">
                      <IconButton onClick={() => handleOpenDrawer(request.id)}>
                        <UnfoldMoreIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>

                  <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleApprove(request)}
                      style={{ marginRight: "10px" }}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleDeny(request)}
                    >
                      Deny
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <ItemDrawer
        open={!!selectedreq}
        onClose={handleCloseDrawer}
        member={selectedreq}
        approve={handleApprove}
        deny={handleDeny}
      />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity}>
          {statusMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default AdminApprovalPage;